import React, { useState } from 'react';
import toast from 'react-hot-toast';
import { generateTelegramCode } from '../composables/fetchAPI'; // Import generateTelegramCode

const TelegramCodePopup = ({
  onClose,
  onNavigateToTelegram,
  setTelegramCode
}: {
  onClose: () => void;
  onNavigateToTelegram: () => void;
  setTelegramCode: (code: string | null) => void;
}) => {
  const [telegramCode, setLocalTelegramCode] = useState<string | null>(null);

  const fetchTelegramCode = async () => {
    try {
      const data = await generateTelegramCode(); // Use generateTelegramCode from fetchAPI.ts
      setLocalTelegramCode(data.code || '000000'); // Default to '000000' if no code is returned
      setTelegramCode(data.code || '000000'); // Update parent state as well
    } catch (error) {
      // toast.error('Failed to generate Telegram code');
    }
  };

  // Fetch the code when the component mounts
  React.useEffect(() => {
    fetchTelegramCode();
  }, []);

  const copyToClipboard = () => {
    if (telegramCode) {
      navigator.clipboard.writeText(telegramCode);
      toast.success('Copied to clipboard!');
    }
  };

  return (
      <div className="relative rounded-lg shadow-lg p-6 w-80" style={{ backgroundColor: 'var(--button-userbox)' }} onClick={(e) => e.stopPropagation()}>
        {/* ปุ่ม X วงกลมแดง */}
        <button
          className="absolute top-0 right-0 w-8 h-8 rounded-full bg-red-500 text-white flex items-center justify-center"
          onClick={onClose}
        >
          X
        </button>

        <h2 className="text-lg font-bold mb-4 text-center" style={{ color: 'var(--text-color)' }}>Your Telegram Code</h2>
        <div className="flex items-center justify-between p-2 rounded mb-4" style={{ backgroundColor: 'var(--secondary-text-color)' }}>
          <span className="text-lg font-mono" style={{ color: 'var(--text-color)' }}>{telegramCode || 'Loading...'}</span>
          <button
            className="bg-blue-500 text-white px-2 py-1 rounded"
            onClick={copyToClipboard}
          >
            Copy
          </button>
        </div>
        <div className="flex justify-between space-x-4">
          <button
            className={`w-full px-3 py-1 rounded ${telegramCode ? 'bg-green-500 text-white' : 'bg-gray-400 text-gray-700'
              }`}
            onClick={onNavigateToTelegram}
            disabled={!telegramCode}
          >
            ไปยัง Telegram
          </button>
        </div>
      </div>
  );
};

export default TelegramCodePopup;